/*
 * Variant picker for the cart drawer's recommendations carousel.
 *
 * Each card renders every variant as an <option> carrying its own formatted
 * price, compare-at price and percent-off, so switching variants needs no
 * network call. Cards with a single variant render no <select> and this element
 * stays inert.
 */
if (!customElements.get('cart-recs-card')) {
  customElements.define(
    'cart-recs-card',
    class CartRecsCard extends HTMLElement {
      connectedCallback() {
        this.select = this.querySelector('[data-cart-recs-select]');
        if (!this.select || this.bound) return;

        this.idInput = this.querySelector('input[name="id"]');
        this.priceEl = this.querySelector('[data-cart-recs-price]');
        this.compareEl = this.querySelector('[data-cart-recs-compare]');
        this.badgeEl = this.querySelector('[data-cart-recs-badge]');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitText = this.querySelector('[data-cart-recs-submit-text]');

        const labels = this.select.closest('.cart-recs__variant');
        this.labelAdd = labels?.dataset.labelAdd || 'Add to cart';
        this.labelSoldOut = labels?.dataset.labelSoldOut || 'Sold out';

        this.select.addEventListener('change', this.onVariantChange.bind(this));
        this.bound = true;
      }

      onVariantChange() {
        const option = this.select.selectedOptions[0];
        if (!option) return;

        // product-form.js reads this input when it builds the add-to-cart body.
        if (this.idInput) this.idInput.value = option.value;

        const price = (option.dataset.price || '').trim();
        const compare = (option.dataset.compare || '').trim();
        const percent = parseInt(option.dataset.percent, 10) || 0;
        const available = option.dataset.available === 'true';

        if (this.priceEl && price) this.priceEl.textContent = price;

        if (this.compareEl) {
          this.compareEl.textContent = compare;
          this.compareEl.classList.toggle('hidden', !compare);
        }

        if (this.badgeEl) {
          const showBadge = percent > 0 && this.badgeEl.dataset.enabled !== 'false';
          this.badgeEl.textContent = `${percent}${this.badgeEl.dataset.suffix || '% off'}`;
          this.badgeEl.classList.toggle('hidden', !showBadge);
        }

        if (this.submitButton) {
          this.submitButton.disabled = !available;
          if (this.submitText) this.submitText.textContent = available ? this.labelAdd : this.labelSoldOut;
        }
      }
    }
  );
}
